/* Ludey navigation additions; Maker remains responsible for cart and variant behavior. */
(() => {
  if (window.ludeyMakerCompatibility) return;
  window.ludeyMakerCompatibility = true;
  const galleries = new WeakSet();
  const videos = new WeakMap();
  function syncGallery(carousel) {
    const active = carousel.querySelector('.card-carousel--block:not([inert]) .product-media--root');
    if (!active) return;
    carousel.querySelectorAll('[data-ludey-media]').forEach(button => {
      if (button.dataset.ludeyMedia === active.dataset.id) {
        button.setAttribute('aria-current', 'true');
      } else button.removeAttribute('aria-current');
    });
  }
  function bindVideo(root) {
    const button = root.querySelector('.ludey-video-play');
    const native = root.querySelector('video');
    const player = native || root.video;
    if (!button || !player || videos.has(root)) return;
    const state = { finished: false };
    videos.set(root, state);
    const pause = () => root.dataset.api === 'youtube' ? player.pauseVideo() : player.pause();
    const show = () => { button.hidden = false; };
    const playing = () => {
      if (state.finished) { pause(); show(); }
      else button.hidden = true;
    };
    const ended = () => {
      state.finished = true;
      button.setAttribute('aria-label', 'Replay video');
      show();
    };
    if (native) {
      native.loop = false;
      native.muted = true;
      native.playsInline = true;
      native.addEventListener('play', playing);
      native.addEventListener('pause', show);
      native.addEventListener('ended', ended);
      button.hidden = !native.paused;
    } else if (root.dataset.api === 'youtube') {
      player.addEventListener('onStateChange', event => {
        if (event.data === 0) ended();
        else if (event.data === 1) playing();
        else if (event.data === 2) show();
      });
      button.hidden = player.getPlayerState() === 1;
    } else if (typeof player.on === 'function') {
      player.on('play', playing);
      player.on('pause', show);
      player.on('ended', ended);
      player.getPaused?.().then(paused => { button.hidden = !paused; }).catch(show);
    }
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const replay = state.finished;
      state.finished = false;
      button.setAttribute('aria-label', 'Play video');
      try {
        if (root.dataset.api === 'youtube') {
          if (replay) player.seekTo(0, true);
          player.playVideo();
        } else if (native) {
          if (replay || native.ended) native.currentTime = 0;
          native.play()?.catch(show);
        } else {
          Promise.resolve(replay ? player.setCurrentTime(0) : undefined).then(() => player.play()).catch(show);
        }
      } catch (_) { show(); }
    });
  }
  function initialize() {
    document.querySelectorAll('product-carousel').forEach(carousel => {
      if (galleries.has(carousel)) return;
      galleries.add(carousel);
      new MutationObserver(() => syncGallery(carousel)).observe(carousel, { subtree: true, attributes: true, attributeFilter: ['inert'] });
      syncGallery(carousel);
    });
    document.querySelectorAll('product-video-element').forEach(bindVideo);
  }
  initialize();
  window.addEventListener('theme:product:mediaLoaded', initialize);
  new MutationObserver(initialize).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', event => {
    const thumbnail = event.target.closest('[data-ludey-media]');
    if (thumbnail) {
      const carousel = thumbnail.closest('product-carousel');
      if (typeof carousel?.goToSlide === 'function') {
        carousel.goToSlide(thumbnail.dataset.ludeyMedia);
        carousel.querySelectorAll('[data-ludey-media]').forEach(button => button.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      }
    }
    document.querySelectorAll('.ludey-desktop-nav details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ludey-desktop-nav details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
})();

/* Optional countdown for The Drop; product availability remains managed in Shopify. */
if (!customElements.get('ludey-drop-countdown')) {
  customElements.define('ludey-drop-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.clock);
      const raw = this.dataset.deadline || '';
      const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(raw);
      const end = validFormat ? Date.parse(raw) : NaN;
      const message = this.querySelector('[data-drop-message]');
      const digits = this.querySelector('.ludey-drop-digits');
      if (!Number.isFinite(end)) {
        this.hidden = this.dataset.editor !== 'true';
        digits.hidden = true;
        message.textContent = 'Set a valid drop date, time, and UTC offset in the collection grid settings.';
        return;
      }
      const update = () => {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        this.hidden = false;
        if (!remaining) {
          digits.hidden = true;
          message.textContent = this.dataset.ended;
          clearInterval(this.clock);
          return;
        }
        digits.hidden = false;
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        for (const [key, value] of Object.entries(values)) this.querySelector(`[data-drop-unit="${key}"]`).textContent = String(value).padStart(2, '0');
      };
      this.clock = setInterval(update, 1000);
      update();
    }
    disconnectedCallback() { clearInterval(this.clock); }
  });
}
